import React from 'react';
import Typist from 'react-typist-component';
import Container from 'react-bootstrap/Container';
import { Jumbotron } from './migration';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  }
};

const iconVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: (i) => ({
    opacity: 1,
    scale: 1,
    transition: {
      delay: i * 0.06,
      type: "spring",
      stiffness: 260,
      damping: 20
    }
  }),
  hover: {
    scale: 1.05,
    transition: {
      duration: 0.2,
      ease: "easeOut"
    }
  }
};

const MainBody = React.forwardRef(({ title, message, jobtitle, icons }, ref) => {
  return (
    <Jumbotron
      fluid
      id="home"
      className="main hero-section title bg-transparent bgstyle text-light min-vh-100 d-flex align-content-center align-items-center flex-wrap m-0"
    >
      <Container className="text-center">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.h1
            ref={ref}
            className="display-1"
            variants={itemVariants}
            style={{
              fontWeight: 700,
              letterSpacing: '-0.02em',
              wordBreak: 'break-word',
              textWrap: 'balance'
            }}
          >
            {title}
          </motion.h1>
          
          <motion.div
            className="lead typist"
            variants={itemVariants}
            style={{ 
              minHeight: '4rem', 
              marginTop: '1.5rem',
              color: '#ffffff',
              fontSize: '1.5rem',
              fontWeight: 500,
              textShadow: '0 2px 10px rgba(0, 0, 0, 0.3)'
            }}
          >
            <Typist loop cursor={<span className="cursor" style={{ fontSize: '1.5em', color: '#ffffff' }}>|</span>}>
              {message}
              <Typist.Delay ms={1500} />
              <Typist.Backspace count={message.length} />
              {jobtitle}
              <Typist.Delay ms={1500} />
              <Typist.Backspace count={jobtitle.length} />
            </Typist>
          </motion.div>

          <motion.div
            className="py-5 hero-socials"
            variants={itemVariants}
          >
            {icons.map((icon, index) => (
              <motion.a
                key={`social-icon-${index}`}
                target="_blank"
                rel="noopener noreferrer"
                href={icon.url}
                aria-label={`My ${icon.image}`}
                custom={index}
                variants={iconVariants}
                whileHover="hover"
                whileTap={{ scale: 0.95 }}
              >
                <Icon icon={`fa6-brands:${icon.image}`} className="socialicons" />
              </motion.a>
            ))}
          </motion.div>

          <motion.div
            variants={itemVariants}
            className="d-flex justify-content-center gap-3 flex-wrap hero-actions"
          >
            <motion.a
              className="btn btn-outline-light btn-lg px-4 py-3"
              href="#aboutme"
              role="button"
              aria-label="Learn more about me"
              whileHover={{ scale: 1.02, boxShadow: "0 6px 18px rgba(255, 255, 255, 0.3)" }}
              whileTap={{ scale: 0.97 }}
              style={{
                borderRadius: '12px',
                borderWidth: '2px',
                fontWeight: 600,
                letterSpacing: '0.5px',
                backdropFilter: 'blur(10px)',
                background: 'rgba(255, 255, 255, 0.1)'
              }}
            >
              More about me
            </motion.a>
            
            <motion.a
              className="btn btn-outline-light btn-lg px-4 py-3"
              href="https://www.buymeacoffee.com/ankitrauniyar"
              target="_blank"
              rel="noopener noreferrer"
              role="button"
              aria-label="Buy me a coffee"
              whileHover={{ scale: 1.02, boxShadow: "0 6px 18px rgba(255, 255, 255, 0.3)" }}
              whileTap={{ scale: 0.97 }}
              style={{
                borderRadius: '12px',
                borderWidth: '2px',
                fontWeight: 600,
                letterSpacing: '0.5px',
                backdropFilter: 'blur(10px)',
                background: 'rgba(255, 255, 255, 0.1)'
              }}
            >
              Buy me a coffee
            </motion.a>
          </motion.div>
        </motion.div>
      </Container>
    </Jumbotron>
  );
});

export default MainBody;
